// extracted by mini-css-extract-plugin
export default {"hello_world":"FooterButton_hello_world__N2Ui1","greenify-text":"FooterButton_greenify-text__ArBa8"};